import { fontFamilyWeightMap } from "../global/fonts";
import { borderTypes } from "./theme";
export const borderTypeOptions = [
    { value: "Straight", label: "Straight" },
    { value: "Rounded", label: "Rounded" },
    { value: "Pill", label: "Pill" },
];
export const cardBorderTypeOptions = [
    { value: "Straight", label: "Straight" },
    { value: "Rounded", label: "Rounded" },
];
export const textTransformOptions = [
    { value: "none", label: "Default" },
    { value: "uppercase", label: "Uppercase" },
    { value: "lowercase", label: "Lowercase" },
];
export const fontWeightSelectOptions = [
    { value: "100", label: "100" },
    { value: "200", label: "200" },
    { value: "300", label: "300" },
    { value: "400", label: "400" },
    { value: "500", label: "500" },
    { value: "600", label: "600" },
    { value: "700", label: "700" },
];
export const borderWithOptions = [
    { value: `0`, label: "No Border" },
    { value: `1px`, label: "1px" },
    { value: `2px`, label: "2px" },
    { value: `3px`, label: "3px" },
    { value: `4px`, label: "4px" },
];
export const parseBorderType = (borderType, onTextarea = false) => {
    switch (borderType) {
        case "Pill":
            return !onTextarea ? borderTypes.pill : `35px`;
        case "Rounded":
            return borderTypes.rounded;
        case "Straight":
            return borderTypes.straight;
    }
};
/**
 * This is a temporary hack to avoid issues during deployment, once the
 * DB migration is executed we can remove it.
 */
const fallbackForOldFonts = {
    "'Inter', 'Helvetica Neue', sans-serif": "Inter",
    "'Work Sans', sans-serif": "Work+Sans",
    "'Rakkas', serif": "Rakkas",
    "'Canela'": "Canela",
};
export const getFontFamilyWeightList = (font) => {
    var _a;
    const validatedFont = (_a = fontFamilyWeightMap[font]) !== null && _a !== void 0 ? _a : fontFamilyWeightMap["Inter"];
    return validatedFont.map((weight) => ({ value: weight, label: weight }));
};
